'use client';

import React, { createContext, useContext } from 'react';
import { SearchEngine } from '@coveo/headless';
import { useSearchEngine } from './useEngine';

interface SearchProviderProps {
  children: React.ReactNode;
  accessToken: string;
  organizationId: string;
  searchHub?: string;
  pipeline?: string;
  analyticsEnabled?: boolean;
}

const SearchContext = createContext<SearchEngine | null>(null);

/**
 * Provides the Coveo search engine to all child components via context.
 *
 * @param props Children and dynamic config
 */
export const SearchProvider = ({
  children,
  accessToken,
  organizationId,
  searchHub,
  pipeline,
}: SearchProviderProps) => {
  const engine = useSearchEngine({
    accessToken,
    organizationId,
    searchHub,
    pipeline,
  });

  return <SearchContext.Provider value={engine}>{children}</SearchContext.Provider>;
};

/**
 * Returns the current Coveo SearchEngine from context.
 */
export const useEngineContext = (): SearchEngine | null => {
  const context = useContext(SearchContext);
  if (!context) {
    return null;
  }
  return context;
};
